<div class="image-crop">

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Crop Image</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="activeModal.dismiss('close')"
    ></button>
  </div>

  <div class="modal-body">
    <div class="bg-white p-2">
      <image-cropper
          class="w-100 p-0"
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="data.maintainAspectRatio"
          [containWithinAspectRatio]="data.containWithinAspectRatio"
          [aspectRatio]="data.aspectRatio"
          [resizeToWidth]="data.cropperMinWidth"
          [resizeToHeight]="data.cropperMinWidth"
          [roundCropper]="data.roundCropper"
          [cropperMinWidth]="data.cropperMinWidth"
          [cropperMinHeight]="data.cropperMinHeight"
          [cropperMaxWidth]="data.cropperMaxWidth"
          [cropperMaxHeight]="data.cropperMaxHeight"
          [canvasRotation]="canvasRotation"
          [transform]="transform"
          [alignImage]="data.alignImage"
          [style.display]="showCropper ? null : 'none'"
          [format]="data.format"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady($event)"
          (loadImageFailed)="loadImageFailed()"
      ></image-cropper>

      <button type="button" class="btn btn-primary w-100 btn-sm mt-2" (click)="submit()">
        Done
      </button>
    </div>
  </div>
</div>
